import React from 'react'
import PropTypes from 'prop-types'
import { ErrorMessage, Field } from 'formik'

import { t } from 'translations'
import { getFieldState } from 'services/Forms'

const Input = ({ customLabelElement, inputGroup, text, fieldClass, inline, validate, customDescription, ...props }) => (
  // Add the required * if the input is mandatory

  <Field validate={validate} {...props}>
    {({ field, form }) => {
      const fieldState = getFieldState(form, field)

      if (inline) {
        return (
          <input
            {...props}
            {...field}
            // Ensure the width will always match the string's length
            className={`merinio-inline-input ${fieldState} ${props.className}`}
          />
        )
      }

      return (
        <div className={`form-group ${fieldState} ${props.required ? 'required' : ''} ${fieldClass}`}>
          <label className="control-label">
            {text.label || t(`${props.module}.${(props.translation || props.name).toUpperCase()}.LABEL`)}
            {customLabelElement}
          </label>
          <div className={`${inputGroup ? 'input-group' : null}`}>
            <input
              {...props}
              {...field}
              // Ensure the width will always match the string's length
              size={(text.placeholder || t(`${props.module}.${(props.translation || props.name).toUpperCase()}.PLACEHOLDER`)).length}
              placeholder={text.placeholder || t(`${props.module}.${(props.translation || props.name).toUpperCase()}.PLACEHOLDER`)}
              className={`form-control ${fieldState}`}
            />

            {inputGroup ? inputGroup : null}
          </div>
          <small className="form-text text-muted">
            {!customDescription ? text.description || t(`${props.module}.${(props.translation || props.name).toUpperCase()}.DESCRIPTION`) : customDescription}
          </small>
          <ErrorMessage name={props.name} render={msg => <span className="text-danger"> {t(msg)}</span>} />
        </div>
      )
    }}
  </Field>
)

export default Input

// Set the proptypes for validation
Input.propTypes = {
  autoComplete: PropTypes.string,
  fieldClass: PropTypes.string,
  module: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  translation: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validation: PropTypes.func,
  required: PropTypes.bool,
  text: PropTypes.object,
  validate: PropTypes.func,
  customLabelElement: PropTypes.element
}
Input.defaultProps = {
  fieldClass: '',
  type: 'text',
  text: {},
  required: false
}
